export const Client = {
    Root: "/",
};

export const Server = {
    Api: {
        Admin: {
            ResetFailedLoginAttemptsCount: "./api/user/ResetLoginAttempts",
        },
        Quote: {
            CalculateQuote: "/api/bqs/CalculateQuote",
            GetProductData: "/api/bqs/GetProductData",
            SendEmail: "/api/bqs/SendEmail",
        },
    },
};

export const Admin = {
    Root: "/admin",
};
